export default class VerfuegbarkeitRequest {
  filialeId: string
  monat: number
  jahr: number
  personen: number
  aussenbereich: boolean
  raucher: boolean
}
